import { Inject, Injectable } from '@angular/core'

import { Observable, firstValueFrom } from 'rxjs'
import { Store } from '@ngrx/store'
import { DepartmentDataService } from '../../features/group/department/services/departmentData.service'
import { SelectedDepartmentService } from '../services/selected-department.service'
import { MainViewActions } from '../../core/layout/state/action-types'

/**
 * DepartmentsResolver - Loads departments on app initialization
 * Migrated from app.states.ts resolve block
 *
 * Loads departments from API and:
 * 1. Dispatches setDepartments action to store
 * 2. Restores last selected department if available
 * 3. Handles errors silently (as per original implementation)
 */
@Injectable({ providedIn: 'root' })
export class DepartmentsResolver  {

    constructor(
        @Inject(DepartmentDataService) private departmentDataService: DepartmentDataService,
        @Inject(SelectedDepartmentService) private selectedDepartmentService: SelectedDepartmentService,
        @Inject(Store) private store: Store
    ) {}

    resolve(
        // route: ActivatedRouteSnapshot,
        // state: RouterStateSnapshot
    ): Observable<void> | Promise<void> | void {

        // Load departments and update store
        return firstValueFrom(this.departmentDataService.getDepartments())
            .then(data => {
                // Dispatch departments to store
                this.store.dispatch(MainViewActions.setDepartments({ departments: data }))

                // Restore last selected department
                const lastSelected = this.selectedDepartmentService.getLastSelectedDepartment()
                if (lastSelected && data.find(department => department.id === lastSelected.id)) {
                    this.store.dispatch(MainViewActions.setSelectedDepartment({ department: lastSelected }))
                } else {
                    this.store.dispatch(MainViewActions.setSelectedDepartment({ department: null }))
                }
            })
            .catch(() => {
                // Do not propagate rejection to route resolve mechanism
                // Matches original behavior from app.states.ts
            })
    }
}
